import { ApiAddress } from '@/services/apis'
import request from '@/services/request'
import { ProjectRole } from './role.model'
import { ID } from '../common.model'

export function getProjectRoles(projectType: string, projectId: ID): Promise<ProjectRole[]> {
  return request.get(ApiAddress.PROJECT_ROLES, { params: { projectType, projectId } })
}

export function addProjectRole(projectType: string, projectId: ID, body) {
  return request.post(ApiAddress.PROJECT_ROLES, body, { params: { projectType, projectId } })
}

export function updateProjectRole(projectType: string, projectId: ID, id: ID, body) {
  return request.put(ApiAddress.PROJECT_ROLE, body, { params: { projectType, projectId, id } })
}

export function deleteProjectRole(projectType: string, projectId: ID, id: ID) {
  return request.delete(ApiAddress.PROJECT_ROLE, { params: { projectType, projectId, id } })
}
